import React, { useMemo } from 'react';

import { Box, Paper, Stack } from '@mui/material';
import { usePreviewMode } from '@wp-block-builder/editor/hooks';

import NavigatorSidebar from '../NavigatorSidebar';

import SubjectBar from './SubjectBar';

type Props = {
  onClick?: () => void;
  children: JsxNode;
  subject: JsxNode;
  preheader: JsxNode;
};
export default function MessageArea({ subject, preheader, onClick, children }: Props) {
  const [view] = usePreviewMode();
  const outsideBoxStyle = useMemo(() => {
    switch (view) {
      case 'DESKTOP':
        return { height: '100%', m: 0 };
      case 'MOBILE':
        return { height: '100%', overflow: 'auto', bgcolor: 'cadet.200' };
    }
  }, [view]);

  const iframeStyle = useMemo(() => {
    switch (view) {
      case 'DESKTOP':
        return { height: '100%', overflow: 'auto' };
      case 'MOBILE':
        return { position: 'relative', overflow: 'auto', height: 668, width: 380, my: 4, mx: 'auto', boxShadow: 4 };
    }
  }, [view]);

  return (
    <Stack height="100%" position="relative">
      <SubjectBar subject={subject} preheader={preheader} />
      <Box component={Paper} onClick={onClick} sx={outsideBoxStyle}>
        <Box sx={iframeStyle}>{children}</Box>
      </Box>
      <NavigatorSidebar />
    </Stack>
  );
}
